module.exports = __webpack_public_path__ + "img/career-a4.ae8f2027.jpg";